/* 
    This uses the websocket from the Odin.NotificationService to power annoucements and notications.
*/

export interface INotificationData {
  messageId: string;
  sentTime: string;
  expirationTime: string;
  scope: NotificationScope;
  severity: NotificationSeverity;
  recipientId?: string;
  title: string;
  detail: string;
  read: boolean;
}

export enum NotificationScope {
  User = 'user',
  Global = 'global'
}

export enum NotificationSeverity {
  Info = 'info',
  Warning = 'warning',
  Critical = 'critical'
}